






















































































































  import { Component, mixins, Watch } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import LazyHydrate from 'vue-lazy-hydration'
  import { Wishlist } from '@one/types/dist/orderpath/app'
  import { WishlistProduct } from '@one/types'
  import pages from '../breadcrumbs'
  import AddToCartMixin from '../../mixins/AddToCartMixin'
  import OneWishlistProductRowMobileTile
    from '~/components/organisms/orderpath/mobile/OneWishlistProductRowMobileTile.vue'

  const wishlist: BindingHelpers = namespace('wishlist')
  const account: BindingHelpers = namespace('account')
  const layout: BindingHelpers = namespace('layout')
  const cart: BindingHelpers = namespace('cart')
  const stocks: BindingHelpers = namespace('stocks')

  @Component({
    middleware: ['isAuthenticatedOrPurchaseEnabled'],
    meta: {
      breadcrumb: {
        name: pages.WISHLIST,
        link: '/wishlist',
      },
    },
    components: {
      OneWishlistProductRowMobileTile,
      OneProductsList: () => import('~/components/organisms/list/OneProductsList.vue'),
      OneWishlistProductRowLine: () => import('~/components/organisms/orderpath/OneWishlistProductRowLine.vue'),
      OneCartWishlistOptionsContainer: () =>
        import('~/components/molecules/carts/OneCartWishlistOptionsContainer.vue'),
      OneCartWishlistOptionsDropdown: () =>
        import('~/components/molecules/dropdowns/OneCartWishlistOptionsDropdown.vue'),
      OneWishlistModalAdd: () => import('~/components/molecules/modals/OneWishlistModalAdd.vue'),
      OneWishlistModalRename: () =>
        import('~/components/molecules/modals/OneWishlistModalRename.vue'),
      OneWishlistModalDelete: () =>
        import('~/components/molecules/modals/OneWishlistModalDelete.vue'),
      OneSelect: () => import('~/components/molecules/selects/OneSelect.vue'),
      LazyHydrate,
    },
  })
  export default class Index extends mixins(AddToCartMixin) {
    @layout.Getter getCurrency: any
    @layout.Getter isGrossSelected: any

    @wishlist.Getter getBasicWishlists: any
    @wishlist.Getter getBasicWishlistById: any
    @wishlist.Getter getWishlists: any
    @wishlist.Getter getCurrentWishlist: any
    @wishlist.Getter getCurrentWishlistId: any
    @wishlist.Getter getWishlistProductsKeys: any
    @wishlist.Getter getWishlistProduct: any
    @wishlist.Getter getWishlistProducts: any
    @wishlist.Getter getWishlistProductPrice: any

    @wishlist.Action fetchWishlists: any
    @wishlist.Action fetchWishlist: any
    @wishlist.Action addProductToWishlist: any
    @wishlist.Action changeWishlistProductOrder: any
    @wishlist.Action removeProductFromWishlist: any
    @wishlist.Action renameWishlist: any
    @wishlist.Action removeWishlist: any
    @wishlist.Action createWishlist: any
    @wishlist.Action selectWishlist: any
    @wishlist.Action copyWishlistToCart: any

    @stocks.Getter getDefaultWarehouseId: any

    @cart.Getter getCurrentCartId: any
    @cart.Action fetchCart: any

    @account.Getter getCustomerType: any

    isQtyAvailable: boolean = false
    showRenameModal: boolean = false
    showDeleteModal: boolean = false
    showCreateModal: boolean = false
    loading: boolean = false
    mainComponentClass = 'one-wishlist-page'

    mounted() {
      this.$plugins.onMounted(this.mainComponentClass, this)
    }

    destroyed() {
      this.$plugins.onUnmounted(this.mainComponentClass)
    }

    @Watch('getDefaultWarehouseId')
    onWarehouseChanged() {
      this.fetchWishlist(this.$store.state.wishlist.selectedWishlist)
    }

    get isWishlistEmpty() {
      return (
        !this.getCurrentWishlist ||
        (this.getCurrentWishlist.products ? this.getCurrentWishlist.products.size < 1 : true)
      )
    }

    get selectableWishlists() {
      return Object.keys(this.getBasicWishlists).map((id: string) => {
        if (this.getBasicWishlistById(id)) {
          return {
            label: this.getBasicWishlistById(id).name,
            value: id,
          }
        }
        return undefined
      })
    }

    get currentWishlistForSelect() {
      return {
        label: this.getCurrentWishlist.name,
        value: this.getCurrentWishlistId,
      }
    }

    getProductFromWishlist(productId: string) {
      return this.getWishlistProduct(this.getCurrentWishlistId)(productId)
    }

    getProductUnit(productId: string) {
      return this.getWishlistProduct(this.getCurrentWishlistId)(productId).measurementUnits
        .orderUnitDescription
    }

    getProductCentralWarehouseQty(productId: string) {
      return this.getWishlistProduct(this.getCurrentWishlistId)(productId).parentWarehouseQuantity
    }

    getProductSelectedWarehouseQty(productId: string) {
      return this.getWishlistProduct(this.getCurrentWishlistId)(productId).warehouseQuantity
    }

    onProductCountChange(productId: string, { amount }: { amount: number }) {
      const product: WishlistProduct = this.getProductFromWishlist(productId)
      const newAmount: number = amount - product.quantity
      const newProduct: Wishlist.Requests.ChangeNumberOfProductInWishlistOption = {
        productId: productId,
        amountOfProducts: newAmount,
      }
      this.addProductToWishlist({
        wishlistId: this.getCurrentWishlistId,
        newProduct,
      }).then(() => {
        this.$notify({
          group: 'alert',
          type: 'success',
          text: this.$t('product_page.alert_added_to_wishlist') as string,
        })
      })
    }

    onDragEnd(ordering: Array<string>) {
      this.changeWishlistProductOrder({
        wishlistId: this.getCurrentWishlistId,
        newOrder: {
          productIds: ordering,
        },
      })
    }

    additiveReducer = (accumulator: number, currentValue: number) => accumulator + currentValue

    get totalWishlistPrice(): number | null {
      if (!this.$utils.hasPricesEnabled) {
        return null
      }
      const productsFromStore = this.getWishlistProducts(this.getCurrentWishlistId)
      if (productsFromStore.size < 1) {
        return 0
      }
      return (
        Array.from(productsFromStore.values())
          // @ts-ignore
          .map((o: Wishlist.WishlistProduct) =>
            this.isGrossSelected ? o.prices!.lineGross : o.prices!.lineNet,
          )
          .reduce(this.additiveReducer)
      )
    }

    get totalNoOfProducts() {
      const productsFromStore = this.getWishlistProducts(this.getCurrentWishlistId)
      if (productsFromStore.size < 1) {
        return 0
      }
      return (
        Array.from(productsFromStore.values())
          // @ts-ignore
          .map((o: Wishlist.WishlistProduct) => o.quantity)
          .reduce(this.additiveReducer)
      )
    }

    onProductRemove(productDataObject: Wishlist.Requests.RemoveProductFromWithListOption) {
      if (!this.loading) {
        this.loading = true
        this.removeProductFromWishlist({
          wishlistId: this.getCurrentWishlistId,
          productDataObject,
        })
          .catch((error: any) => {
            this.$logger.warn(error)
          })
          .finally(() => {
            this.loading = false
          })
      }
    }

    onAddToCart(productId: string, { amount }: { amount: number }) {
      this.addToCart(productId, amount, 'wishlist')
    }

    addAllToCart() {
      this.$wait.start('add-all-to-cart')
      this.copyWishlistToCart({
        wishlistId: this.getCurrentWishlistId,
        cartId: { cartId: this.getCurrentCartId },
      })
        .then(() => {
          this.fetchCart(this.getCurrentCartId)
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('product_page.alert_added_all_to_cart') as string,
          })
        })
        .finally(() => this.$wait.end('add-all-to-cart'))
    }

    onWishlistChanged(wishlistId: string) {
      this.selectWishlist(wishlistId)
    }

    onWishlistRename(name: string) {
      this.$wait.start('wishlist-renaming')
      this.$orderpath.wishlist
        .renameWishlist(name)
        .then(() => {
          this.showRenameModal = false
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('wishlist.modals.wishlist_renamed') as string,
          })
        })
        .finally(() => {
          setTimeout(() => this.$wait.end('wishlist-renaming'), 250)
        })
    }

    onWishlistCreate(name: string) {
      this.$wait.start('wishlist-creating')
      this.$orderpath.wishlist
        .createWishlistAndSelect(name)
        .then(() => {
          this.showCreateModal = false
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('wishlist.modals.wishlist_created') as string,
          })
        })
        .finally(() => {
          setTimeout(() => this.$wait.end('wishlist-creating'), 250)
        })
    }

    onWishlistDelete() {
      this.$wait.start('wishlist-removing')
      this.$orderpath.wishlist
        .removeWishlist()
        .then(() => {
          this.showDeleteModal = false
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('wishlist.modals.wishlist_removed') as string,
          })
        })
        .finally(() => {
          setTimeout(() => this.$wait.end('wishlist-removing'), 250)
        })
    }

    fetch({ store, redirect }: any) {
      store.commit('layout/TOGGLE_BREADCRUMBS', true)

      if (!store.getters['stocks/hasWarehouses']) {
        this.$notify({
          group: 'alert',
          type: 'error',
          text: this.$t('errors.no_warehouses_cart') as string,
        })
        redirect('/')
      }
    }

    get checkResolution(): boolean {
      return this.$utils.isMobileOrTablet(this.$mq)
    }
  }
